exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3717n{position:relative}._16T3H{position:absolute;text-align:center;width:100%}", ""]);

// exports
exports.locals = {
	"wrapper": "_3717n",
	"text": "_16T3H"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[hash:base64:5]!./~/postcss-loader!./client/app/components/progress-bar/style.css
 ** module id = 191
 ** module chunks = 0
 **/